export default __webpack_public_path__ + "static/solution-puzzle.url-69fd06c2dbf6ae18957ec28c0a908dc1.svg";